import {
  type Configuration,
  PublicClientApplication,
  type RedirectRequest,
} from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID || '',
    authority:
      import.meta.env.VITE_MSAL_AUTHORITY ||
      'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin + '/oauth2/callback',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest: RedirectRequest = {
  scopes: ['User.Read'],
};
